import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Slide, makeStyles } from '@material-ui/core';

import { Box, Flex, Image, MUIModal } from 'Components/Base';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
Transition.displayName = 'Transition';

const useModalStyle = makeStyles({
  paper: ({ topOffset }) => ({
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    bottom: 0,
    margin: 0,
    paddingTop: topOffset ?? 0,
    maxHeight: 'unset',
    maxWidth: 'unset',
    '& > #close-icon': {
      top: topOffset || 20,
    },
    '@media (min-width:768px)': {
      maxWidth: '600px',
      maxHeight: 'calc(100% - 64px)',
      height: 'auto',
      width: '100%',
      borderRadius: '16px',
      position: 'relative',
      bottom: 'inherit',
    },
  }),
});

const useModalContentStyle = makeStyles({
  root: () => ({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    '&:first-child': {
      paddingTop: 0,
    },
  }),
});

const ImageLogo = styled(Image)`
  max-height: 24px;
`;

const ClearModal = ({ children, muiProps }) => {
  const { topOffset } = useOffset();
  const modalClasses = useModalStyle({ topOffset });
  const modalContentClasses = useModalContentStyle();
  const { isActive, toggleComponent, onOpen, onClose, muiStyles, ...restMuiProps } = muiProps;

  return (
    <MUIModal
      TransitionComponent={Transition}
      isOpen={isActive}
      onOpenModal={onOpen}
      onCloseModal={onClose}
      innerProps={{ height: 'auto', display: 'flex', flex: '1' }}
      classes={modalClasses}
      modalContentProps={{ classes: { ...modalContentClasses, ...muiStyles } }}
      toggleComponent={toggleComponent}
      modalTitle={
        <Flex justifyContent={'center'} flex={'0 0 auto'} width={1}>
          <ImageLogo src={'/assets/images/classroom/clearButton-1x.png'} width={'90px'} />
        </Flex>
      }
      {...restMuiProps}
    >
      <Box px={4} pt={4} pb={7} width={1}>
        {children}
      </Box>
    </MUIModal>
  );
};

ClearModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  muiProps: PropTypes.shape({
    toggleComponent: PropTypes.element,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isActive: PropTypes.bool,
  }),
};

export default ClearModal;
